import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText } from '@guryou/html-components';

const WidgetNotPaidFor = () => {
  const { t } = useTranslation();

  return (
    <Block margin={30} xs={12}>
      <DefaultText color="green" xs={4}>
        {t('GENERAL.providerHasNotPaid')}
      </DefaultText>
    </Block>
  );
};

export default WidgetNotPaidFor;
